import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Chip, Grid, Link, Stack, Typography } from '@mui/material'

import { InternalGameScreenshot } from '../../../../api/screenshot-links'
import { ScreenshotThumbnail } from '../ScreenshotThumbnail/ScreenshotThumbnail'

type CommentScreenshotsProps = {
  screenshots: InternalGameScreenshot[]
}

export const CommentScreenshots: FC<CommentScreenshotsProps> = ({ screenshots }) => {
  const { t } = useTranslation()
  const isSingle = screenshots.length === 1
  return (
    <Grid container spacing={2}>
      {screenshots.map((screenshot) => {
        const alt = t('internal-analysts:implementation_screenshot_alt', { version: screenshot.gameVersion ?? '---' })
        return (
          <Grid item key={screenshot.id} xs={isSingle ? 12 : 6} sm={isSingle ? 12 : 4}>
            <Stack spacing={0.5}>
              <Link href={screenshot.url} target="_blank" rel="noopener noreferrer" aria-label={t('internal-analysts:implementation_open_image')}>
                <ScreenshotThumbnail url={screenshot.url} alt={alt} height={isSingle ? 360 : 160} />
              </Link>
              <Typography variant="body2" color="text.secondary">
                {t('internal-analysts:comment_version', { version: screenshot.gameVersion ?? '---' })}
              </Typography>
              {!isSingle && screenshot.commentId && (
                <Box>
                  <Chip size="small" color="warning" label={t('internal-analysts:implementation_comment_has_one')} />
                </Box>
              )}
            </Stack>
          </Grid>
        )
      })}
    </Grid>
  )
}
